import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "help",
  "use": "help-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol viewBox=\"0 0 90 90\" id=\"help\"><title>资源 105</title><g id=\"help_图层_2\" data-name=\"图层 2\"><g id=\"help_图层_1-2\" data-name=\"图层 1\"><ellipse cx=\"44.81\" cy=\"60.91\" rx=\"4.57\" ry=\"4.51\" /><path d=\"M57.07,39.9a29.63,29.63,0,0,1-5.71,5.79,10.82,10.82,0,0,0-2.81,3.05,10.29,10.29,0,0,0-.5,4.13h-6.5c0-.94,0-1.51,0-1.72a11.5,11.5,0,0,1,1-5.23,15.91,15.91,0,0,1,4.18-4.62,31.72,31.72,0,0,0,3.74-3.36,4.54,4.54,0,0,0,.95-2.77,4.69,4.69,0,0,0-1.67-3.6,6.5,6.5,0,0,0-4.5-1.5,6.81,6.81,0,0,0-4.57,1.56,9.48,9.48,0,0,0-2.53,4.75c-.23,1.34-6.64,1.91-6.57-.81a11.23,11.23,0,0,1,3.88-7.8A13.73,13.73,0,0,1,45,24.58q6.17,0,9.81,3.25a9.84,9.84,0,0,1,3.64,7.56A8.3,8.3,0,0,1,57.07,39.9Z\" /><path d=\"M45,5A40,40,0,1,1,5,45,40,40,0,0,1,45,5m0-5A45,45,0,1,0,90,45,45,45,0,0,0,45,0Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/help.svg
// module id = /9hz
// module chunks = 264